import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=4d5905d0&scoped=true&lang=pug"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=4d5905d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5905d0",
  null
  
)

export default component.exports